module.exports = __webpack_public_path__ + "media/bootstrap-icons/circle-c5d57a8f.svg";